import React from 'react';
import { Mail } from 'lucide-react';

interface LogoMarkProps {
  size?: number;
  className?: string;
}

export const LogoMark: React.FC<LogoMarkProps> = ({ size = 32, className = '' }) => (
  <div 
    className={`rounded-lg bg-gradient-to-br from-[#0284c7] to-[#1264d1] flex items-center justify-center shrink-0 ${className}`}
    style={{ width: size, height: size }}
  >
    <Mail size={size * 0.55} className="text-white" />
  </div>
);

export default LogoMark;
